<div class="sb-root" [class.sb-collapsed]="isCollapsed">

  <div class="sb-header">
    <div class="sb-brand" *ngIf="!isCollapsed">
      <img src="assets/logo/spark-horizontal-transparent.png" alt="Spark Logo" class="sb-logo">
    </div>
    <div class="sb-brand sb-brand-collapsed" *ngIf="isCollapsed">
      <img src="assets/logo/spark-icon-transparent.png" alt="Spark Logo" class="sb-logo-small">
    </div>
    <button class="sb-toggle-btn" (click)="onToggleSidebar()"
      [attr.aria-label]="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'">
      <img src="assets/icons/sidebar-collapse-arrow.svg" alt="" class="sb-toggle-icon" [class.sb-rotated]="isCollapsed">
    </button>
  </div>

  <div class="sb-body">

    <button class="sb-new-chat" *ngIf="!isCollapsed" (click)="onNewChatClick()">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round">
        <path d="M12 5v14M5 12h14" />
      </svg>
      New Chat
    </button>
    <button class="sb-new-chat sb-new-chat-collapsed" *ngIf="isCollapsed" title="New Chat" (click)="onNewChatClick()">
      <i class="fas fa-plus"></i>
    </button>

    <div class="sb-section" *ngIf="canViewInferences">
      <div class="sb-section-label" *ngIf="!isCollapsed">Insights</div>
      <div class="sb-rail" [class.sb-rail-collapsed]="isCollapsed">
        <div class="sb-nav-item" [class.sb-selected]="isClustersSelected" (click)="onClustersClick()"
          [title]="isCollapsed ? 'Clusters' : 'Group documents, then generate inferences'">
          <span class="sb-nav-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="6.5" cy="7" r="2.25" />
              <circle cx="17.5" cy="7" r="2.25" />
              <circle cx="12" cy="17" r="2.25" />
              <path d="M8.4 8.4l2.4 6.2M15.6 8.4l-2.4 6.2" />
            </svg>
          </span>
          <span class="sb-nav-label" *ngIf="!isCollapsed">Clusters</span>
        </div>
        <div class="sb-nav-item" [class.sb-selected]="isInferencesSelected" (click)="onInferencesClick()"
          [title]="isCollapsed ? 'Inferences' : 'Review generated inferences'">
          <span class="sb-nav-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 18h6" />
              <path d="M10 21h4" />
              <path d="M12 3a6 6 0 00-3.5 10.8c.7.5 1.1 1.2 1.2 2V17h4.6v-.5c.1-.8.5-1.5 1.2-2A6 6 0 0012 3z" />
            </svg>
          </span>
          <span class="sb-nav-label" *ngIf="!isCollapsed">Inferences</span>
        </div>
      </div>
    </div>

    <div class="sb-section">
      <div class="sb-nav-item" [class.sb-selected]="isLeaveSelected" (click)="onLeaveClick()"
        [title]="isCollapsed ? 'Leave' : 'Request and manage leave'">
        <span class="sb-nav-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="5" width="18" height="16" rx="2" />
            <path d="M3 10h18" />
            <path d="M8 3v4M16 3v4" />
            <path d="M8 15h3M13 15h3M8 18h8" />
          </svg>
        </span>
        <span class="sb-nav-label" *ngIf="!isCollapsed">Leave</span>
      </div>
      <div class="sb-nav-item" *ngIf="canViewAgentHooks" [class.sb-selected]="isAgentHooksSelected" (click)="onAgentHooksClick()"
        [title]="isCollapsed ? 'Agent hooks' : 'Connect events to agents built in DPE'">
        <span class="sb-nav-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="6" cy="6" r="2.5" />
            <circle cx="18" cy="18" r="2.5" />
            <path d="M8.5 6H14a4 4 0 014 4v5.5" />
            <path d="M15.5 18H10a4 4 0 01-4-4V8.5" opacity="0.45" />
          </svg>
        </span>
        <span class="sb-nav-label" *ngIf="!isCollapsed">Agent hooks</span>
      </div>
      <div class="sb-nav-item" (click)="onPromptsClick()" [title]="isCollapsed ? 'Prompts' : 'Browse prompt library'">
        <span class="sb-nav-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 3l1.6 4.7L18 9l-4.4 1.3L12 15l-1.6-4.7L6 9l4.4-1.3L12 3z" />
            <path d="M5 17l.8 2.2L8 20l-2.2.8L5 23l-.8-2.2L2 20l2.2-.8L5 17z" />
          </svg>
        </span>
        <span class="sb-nav-label" *ngIf="!isCollapsed">Prompts</span>
      </div>
    </div>

    <div class="sb-history" *ngIf="!isCollapsed">
      <div class="sb-history-loading" *ngIf="isLoadingHistory">Loading chat history&hellip;</div>

      <div class="sb-section" *ngIf="!isLoadingHistory && last7DaysChats.length > 0">
        <div class="sb-section-label">Recent Conversations</div>
        <div class="sb-chat-item" [class.sb-selected]="selectedChatHistoryId === chatHistoryItem.id"
          *ngFor="let chatHistoryItem of last7DaysChats" (click)="onChatHistoryItemClick(chatHistoryItem)">
          <span class="sb-nav-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
            </svg>
          </span>
          <span class="sb-chat-title" [title]="capitalizeFirst(chatHistoryItem.chatLabel)">{{ chatHistoryItem.chatLabel }}</span>
          <span class="sb-chat-actions">
            <button class="sb-icon-btn" (click)="onEditChat($event, chatHistoryItem)" title="Rename chat">
              <img src="assets/icons/edit-icon.svg" alt="Rename" class="sb-action-icon">
            </button>
            <button class="sb-icon-btn" (click)="onDeleteChat($event, chatHistoryItem.id)" title="Delete chat">
              <img src="assets/icons/del_chat.svg" alt="Delete" class="sb-action-icon">
            </button>
          </span>
        </div>
      </div>

      <div class="sb-section" *ngIf="!isLoadingHistory && earlierChats.length > 0">
        <div class="sb-section-label">Earlier</div>
        <div class="sb-chat-item" [class.sb-selected]="selectedChatHistoryId === chatHistoryItem.id"
          *ngFor="let chatHistoryItem of earlierChats" (click)="onChatHistoryItemClick(chatHistoryItem)">
          <span class="sb-nav-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
            </svg>
          </span>
          <span class="sb-chat-title" [title]="capitalizeFirst(chatHistoryItem.chatLabel)">{{ chatHistoryItem.chatLabel }}</span>
          <span class="sb-chat-actions">
            <button class="sb-icon-btn" (click)="onEditChat($event, chatHistoryItem)" title="Rename chat">
              <img src="assets/icons/edit-icon.svg" alt="Rename" class="sb-action-icon">
            </button>
            <button class="sb-icon-btn" (click)="onDeleteChat($event, chatHistoryItem.id)" title="Delete chat">
              <img src="assets/icons/del_chat.svg" alt="Delete" class="sb-action-icon">
            </button>
          </span>
        </div>
      </div>

      <div class="sb-empty" *ngIf="!isLoadingHistory && last7DaysChats.length === 0 && earlierChats.length === 0">
        No chat history yet. Start a new conversation!
      </div>
    </div>

    <div class="sb-history-collapsed" *ngIf="isCollapsed && !isLoadingHistory && (last7DaysChats.length > 0 || earlierChats.length > 0)">
      <div class="sb-collapsed-item" [class.sb-selected]="selectedChatHistoryId === chatHistoryItem.id"
        *ngFor="let chatHistoryItem of last7DaysChats" [title]="chatHistoryItem.chatLabel"
        (click)="onChatHistoryItemClick(chatHistoryItem)">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
        </svg>
      </div>
      <div class="sb-collapsed-item" [class.sb-selected]="selectedChatHistoryId === chatHistoryItem.id"
        *ngFor="let chatHistoryItem of earlierChats" [title]="chatHistoryItem.chatLabel"
        (click)="onChatHistoryItemClick(chatHistoryItem)">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
        </svg>
      </div>
    </div>

  </div>

  <div class="sb-footer">
    <div class="sb-user" *ngIf="!isCollapsed">
      <div class="sb-avatar">
        <img src="assets/icons/user-solid-full.svg" alt="" class="sb-avatar-icon">
      </div>
      <span class="sb-user-name">{{username}}</span>
      <div class="sb-menu-wrap user-menu-container">
        <button class="sb-menu-btn" title="Menu" (click)="toggleUserMenu()">
          <img src="assets/icons/dots-icon.svg" alt="Menu" class="sb-menu-btn-icon">
        </button>
        <div class="sb-menu-dropdown" [class.sb-menu-open]="showUserMenu">
          <div class="sb-menu-item" *ngIf="canViewFeedback" (click)="onFeedbackClick()">
            <img src="assets/icons/feedback-icon.svg" alt="" class="sb-menu-icon">
            <span>Feedback</span>
          </div>
          <div class="sb-menu-divider" *ngIf="canViewFeedback"></div>
          <div class="sb-menu-item" (click)="onChangePasswordClick()">
            <img src="assets/icons/lock_icon.svg" alt="" class="sb-menu-icon">
            <span>Change Password</span>
          </div>
          <div class="sb-menu-divider"></div>
          <div class="sb-menu-item" (click)="onLogoutClick()">
            <img src="assets/icons/logout-button.svg" alt="" class="sb-menu-icon">
            <span>Logout</span>
          </div>
        </div>
      </div>
    </div>
    <div class="sb-user sb-user-collapsed" *ngIf="isCollapsed">
      <div class="sb-avatar" [title]="username">
        <img src="assets/icons/user-solid-full.svg" alt="" class="sb-avatar-icon">
      </div>
      <div class="sb-menu-wrap user-menu-container">
        <button class="sb-menu-btn sb-menu-btn-collapsed" title="Menu" (click)="toggleUserMenu()">
          <img src="assets/icons/dots-icon.svg" alt="Menu" class="sb-menu-btn-icon">
        </button>
        <div class="sb-menu-dropdown sb-menu-dropdown-collapsed" [class.sb-menu-open]="showUserMenu">
          <div class="sb-menu-item" *ngIf="canViewFeedback" (click)="onFeedbackClick()">
            <img src="assets/icons/feedback-icon.svg" alt="" class="sb-menu-icon">
            <span>Feedback</span>
          </div>
          <div class="sb-menu-divider" *ngIf="canViewFeedback"></div>
          <div class="sb-menu-item" (click)="onChangePasswordClick()">
            <img src="assets/icons/lock_icon.svg" alt="" class="sb-menu-icon">
            <span>Change Password</span>
          </div>
          <div class="sb-menu-divider"></div>
          <div class="sb-menu-item" (click)="onLogoutClick()">
            <img src="assets/icons/logout-button.svg" alt="" class="sb-menu-icon">
            <span>Logout</span>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
